import ElibaryLinkListContainer from "../Component/ElibaryLinkListContainer"
import HoilDayListContainer from "../Component/HoildayListContainer"
import LibaryNavigationLinkSection from "../Component/LibaryNavigationSection"
import "../css/pages/hoilday-list.css"
import HolidayListTable from "./admin/HolidayList/HolidayListTable"
import Footer from "./Website/Footer"
import Navbar from "./Website/NavBar"

const HolidayList = () => {
  return (
    <>
    <Navbar/>
    <div className="holiday-list-page w-full pt-20 px-5">
        <h1 className='text-3xl font-bold text-gray-900 mb-4 text-center mt-10'>Holiday List Details</h1>
        <HolidayListTable/>
    </div>
    <Footer/>
    </>
    )
}

export default HolidayList
